const EventBus = window.VueEventBus
import PageMixins from '../../_mixins/pages'

export default {
  name: 're-login-status',
  mixins: [PageMixins], // authCheck // logout
  props: {
    containerClass: {default: 're-login-status'},
    signIn: {default: 'Sign in'},
    signInClass: {default: 're-status-sign-in-link'},
    signOut: {default: 'Sign out'},
    signOutClass: {default: 're-status-sign-out-link'},
    profile: {default: 'My Account'},
    profileClass: {default: 're-status-profile-link'},
    signedInLinkToProfile: {default: true, type: Boolean},
    reloadAfterSignOut: {default: false, type: Boolean},
  },
  data: () => ({
    routeIsProfile: false,
    showSignInLink: true,
    showProfileLink: false,
    showSignOutLink: false,
  }),
  created() {
    const routeName = this.$route.name
    this.routeIsProfile = routeName === 'user.profile'
    this.setStatus()
    EventBus.$on('user.logout', () => {
      this.setStatus()
    })
  },
  methods: {
    setStatus() {
      const routeIsProfile = this.routeIsProfile
      const showSignIn = this.showSignInLink = !this.authCheck || !this.authUser || !this.authUser.verified
      this.showProfileLink = !showSignIn && !routeIsProfile && this.signedInLinkToProfile
      this.showSignOutLink = !showSignIn && (routeIsProfile || !this.signedInLinkToProfile)
    },
    async userSignOut() {
      await this.logout()
      if (this.reloadAfterSignOut) {
        window.location.reload()
      }
    }
  }
}
